// import NavLinkDropdown from '@common/components/NavLinkDropdown';
// import { ReactComponent as Down } from '@common/icons/MenuDown.svg';
// import Button from '@common/../lib-components/Button';

import Product from '@common/models/Product';
import Arrow from '@images/downVector.svg';
// import GreyBgArrow from '@images/BlackArrow.svg';
import Image from '@lib/Image';
import classnames from 'classnames';
import React, { useState } from 'react';
interface SelectVariantsProps {
  product: Product;
  selectedOptions: Array<number>;
  setSelectedOptions: (selectedOptions: Array<number>) => void;
  quantity: number;
  setQuantity: (quantity: number) => void;
  quickView?: boolean;
}

const SelectVariants: React.FC<SelectVariantsProps> = ({
  product,
  selectedOptions,
  setSelectedOptions,
  quickView,
  // designType,
}) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(null);
  const [isHover, setIsHover] = useState(null);
  return (
    <>
      {product.optionNames.map((optionName, index) => (
        // <div key={optionName} className="mt-25 first:mt-0 grid grid-cols-auto md:grid-cols-2 md:w-220 gap-36 md:gap-20">
        <div key={optionName} className="mt-25 first:mt-0 grid grid-cols-2 md:w-220 gap-20">
          <div
            className="text-textColor font-normal text-16 leading-22 flex items-center flex-wrap"
            color-customisation="page-body-text"
            id={'variant-type-' + (parseInt(index) + 1)}
          >
            {optionName}
          </div>
          {OtheroptionsBar(
            optionName,
            product,
            index,
            selectedOptions,
            setSelectedOptions,
            isDropdownOpen,
            setIsDropdownOpen,
            isHover,
            setIsHover,
            quickView,
          )}
        </div>
      ))}
    </>
  );
};

//OtheroptionsBar
const OtheroptionsBar = (
  optionName,
  product,
  index,
  selectedOptions,
  setSelectedOptions,
  isDropdownOpen,
  setIsDropdownOpen,
  isHover,
  setIsHover,
  quickView,
) => {
  return (
    <div
      tabIndex={0}
      onBlur={(e) => {
        e.preventDefault();
        setIsDropdownOpen(null);
      }}
      className="focus:outline-none justify-self-end md:justify-self-auto"
    >
      <div className="flex flex-col">
        <div className="flex items-center">
          <div
            className={classnames(
              'flex justify-between cursor-pointer pl-10 items-center rounded-5 flex-wrap focus:outline-none focus:h-200 bg-white border border-slideBorder',
              {
                'w-165 min-w-165 h-44 md:h-36': !quickView,
                'w-164 min-w-164 h-36': quickView,
              },
            )}
            onClick={(e) => {
              e.preventDefault();
              isDropdownOpen === index ? setIsDropdownOpen(null) : setIsDropdownOpen(index);
            }}
          >
            <span
              className="text-16 leading-22 font-normal text-textScolor"
              color-customisation="page-body-text"
              id={
                'type' +
                (parseInt(index) + 1) +
                '-v' +
                (parseInt(
                  product?.allOptionValues[index]?.indexOf(product?.allOptionValues[index]?.[selectedOptions[index]]),
                ) +
                  1)
              }
            >
              {product?.allOptionValues[index]?.[selectedOptions[index]]}
            </span>
            <div className="cursor-pointer mr-16">
              <Image
                className={classnames('object-contain min-w-10', { 'transform rotate-180': isDropdownOpen === index })}
                src={Arrow}
                noDefaultDimensions
                alt="Down"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="">
        {isDropdownOpen === index && (
          <div
            className={classnames(
              'flex cursor-pointer absolute flex-col mt-4 border overflow-y-scroll border-slideBorder bg-white z-40 rounded-5',
              {
                'w-164 min-w-164': true,
                'max-h-100': quickView,
                'max-h-150': !quickView,
              },
            )}
            onMouseLeave={(e) => {
              e.preventDefault();
              setIsDropdownOpen(null);
            }}
            onBlur={(e) => {
              e.preventDefault();
              setIsHover(null);
            }}
          >
            {product?.allOptionValues[index]?.map((optionValue, optionIndex) => (
              <>
                {product?.allOptionValues[index]?.[selectedOptions[index]] !== optionValue && (
                  <div
                    className="flex hover:bg-bgLight text-textScolor text-16 leading-22 font-normal pl-10 min-h-40 items-center focus:bg-opacity-15 focus:bg-textColor"
                    key={optionValue}
                    onClick={() => {
                      const newSelectedOptions = [...selectedOptions];
                      newSelectedOptions[index] = optionIndex;
                      setSelectedOptions(newSelectedOptions);
                      setIsDropdownOpen(null);
                    }}
                    color-customisation="page-body-text"
                    id={'type' + (parseInt(index) + 1) + '-v' + (parseInt(optionIndex) + 1)}
                  >
                    {optionValue}
                  </div>
                )}
              </>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default SelectVariants;
